module.exports = __webpack_public_path__ + "static/media/close.eba81715.svg";